import { render, staticRenderFns } from "./confirm-order.vue?vue&type=template&id=0d9edcb1&scoped=true"
import script from "./confirm-order.vue?vue&type=script&lang=js"
export * from "./confirm-order.vue?vue&type=script&lang=js"
import style0 from "./confirm-order.vue?vue&type=style&index=0&id=0d9edcb1&prod&lang=scss"
import style1 from "./confirm-order.vue?vue&type=style&index=1&id=0d9edcb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9edcb1",
  null
  
)

export default component.exports